import React, { useState } from "react";
import { IPriceSize } from "../../shared/interfaces/size";
import { locationService } from "../../services/location.service";
import { IStorage, IStorageBody } from "../../shared/interfaces/storage";
import { tS } from "../../services/translation.service";

interface IProps {
  locationId: number | undefined;
  selectedSize: IPriceSize | undefined;
  setSelectedStorage: (storage: IStorage) => void;
  onNextStep: () => void;
  isGerman: boolean;
  setSelectedSize: (size: IPriceSize) => void;
  sizeList: IPriceSize[];
  isBlind: boolean;
  selectedLanguage: number;
}

export const HandicappedStep = (props: IProps) => {
  const { locationId, selectedSize, setSelectedStorage, onNextStep, isGerman, setSelectedSize, sizeList, isBlind, selectedLanguage } = props;
  const [isError, setError] = useState(false);
  
  const [errorMessage, setErrorMessage] = useState("")
  const [buttonsEnabled, setButtonsEnabled] = useState(true);
  const [handicapped, setHandicapped] = useState(false);
  const [alternativeSize, setAlternativeSize] = useState(false);

  
  const createStorage = (userInput: boolean) => {
    let handicappedLocal: boolean = false;
    if(alternativeSize === false) {
      handicappedLocal = userInput;
      setHandicapped(userInput);
      console.log('handicapped updated');
    } else {
      if(userInput === false) {
        setError(true);
        setErrorMessage(tS.gT(tS.P.YouHaveCancelledTheBooking, selectedLanguage));
        setButtonsEnabled(false);
        return;
      } else {
        handicappedLocal = handicapped;
      }
    }
    console.log('alternativeSize: ' + alternativeSize + ", handicapped: " + handicapped)
    if (!locationId || !selectedSize) {
      return;
    }

    const bodyRequest: IStorageBody = {
      locationId: locationId,
       carrierId: 15, // for dev 28/42 for prod 8/15
      sizeId: selectedSize.sizeId,
      handicapped: handicappedLocal,
      resendCount: 0,
      resend: false,
      german: isGerman,
      selectedLanguage: selectedLanguage
    };
    locationService
      .createStorageRequest(bodyRequest)
      .then((response) => {
        if (response) {
          // save the response for later use
          if(response.success === true) {
            setSelectedStorage(response);
            onNextStep();
          } else {
            setError(true);
            setErrorMessage(response.messageLine1.replace(/u013E/g, 'ľ'));
            if(response.alternativeSize === false) {
              setButtonsEnabled(false);
            } else {
              setAlternativeSize(true);

              let matchingSize: IPriceSize | undefined = sizeList.find(item => item.sizeId === response.alternativeSizeId)
              if(matchingSize === undefined) {
                setError(true);
                setErrorMessage("Size undefined")
                setButtonsEnabled(false);
                return;
              }
              setSelectedSize(
                {
                  sizeId: response.alternativeSizeId,
                  sizeName: matchingSize.sizeName,
                  matchingName: matchingSize.matchingName,
                  threeHourPrice: matchingSize.threeHourPrice,
                  twoFourHourPrice: matchingSize.twoFourHourPrice,
                  depth: matchingSize.depth,
                  height: matchingSize.height,
                  width: matchingSize.width
                }
              )
            }
          }
        }
      })
      .catch((err) => {
        setError(true);
        setErrorMessage(err.response.data.message)
        setButtonsEnabled(false);
      });
  };
  return (
    <div className="container">
      <div className="container">
        {!isError && (<p>{tS.gT(tS.P.DoYouNeedUnder13, selectedLanguage)}</p>)}
        {isError && (
          <p>
            {errorMessage.split("\n").map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
          }}
        >
          {buttonsEnabled && (<button style={{ marginRight: 10 }} onClick={() => createStorage(true)}>
            {!isError ? tS.gT(tS.P.Yes, selectedLanguage) :
             (!isBlind ? tS.gT(tS.P.Yes, selectedLanguage) : tS.gT(tS.P.YesINeed, selectedLanguage))}
          </button>)}
          {buttonsEnabled && (<button onClick={() => createStorage(false)}>
            {!isError ? tS.gT(tS.P.No, selectedLanguage) :
             (!isBlind ? tS.gT(tS.P.No, selectedLanguage) : tS.gT(tS.P.NoIDontNeed, selectedLanguage))}
          </button>)}
        </div>
      </div>
    </div>
  );
};
